module.exports = __webpack_public_path__ + "static/media/SidebarLogo.598b4db8.svg";